module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "preface1",
    attrs: {
      "id": "fm1"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312876531_ch.png"
    }
  }), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here’s the rest of it, Gandrader. I hope it’s what you wanted."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This volume is especially for the participants of the newsgroup rec.arts.sf.composition, both for specific help and for just being there, a community where it’s normal to want to talk about writing."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks once again to Graydon and Emmet and Hrolfr for reading chapters as they were written, Julie Pascal for suggesting the title of this volume, Michael Grant for all the semicolons, Mary Lace for having such appropriate reactions, David Goldfarb, Mary Kuhner and Janet Kegg for helpful readings, Sketty Library for getting me books, and Patrick Nielsen Hayden for doing all the difficult stuff."), _c('br'), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15aa48a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312876531_epub_fm1_r1.vue
// module id = 69
// module chunks = 0